import ImageWithBasePath from "@/components/image-with-base-path"
import { all_routes } from "@/routes/all_routes"
import { Link } from "react-router"

const FooterSection = () => {
  return (
<>
  {/* Footer */}
  <footer className="footer-fifteen">
    <div className="container">
      <div className="footer-content">
        <h2 className="footer-text">
          {" "}
          LET’S US TALK <span>TOGETHER </span>{" "}
        </h2>
      </div>
      {/* Footer Top */}
      <div className="footer-top">
        <div className="row row-gap-sm-5 row-gap-5">
          <div className="col-xl-4 col-lg-4 col-md-12">
            {/* Footer Widget */}
            <div className="footer-widget footer-about">
              <div className="footer-logo">
                <ImageWithBasePath src="assets/img/logo-15.svg" alt="logo" />
              </div>
              <div className="footer-about-content">
                <p>
                  We are a trusted diagnostic laboratory offering accurate
                  tests, advanced technology, and patient-focused care.
                </p>
                <div className="social-icon">
                  <Link to="#" aria-label="Facebook">
                    <i className="fab fa-facebook-f" />
                  </Link>
                  <Link to="#" aria-label="Twitter">
                    <i className="fab fa-twitter" />
                  </Link>
                  <Link to="#" aria-label="Instagram">
                    <i className="fab fa-instagram" />
                  </Link>
                  <Link to="#" aria-label="LinkedIn">
                    <i className="fab fa-linkedin-in" />
                  </Link>
                </div>
              </div>
            </div>
            {/* Footer Widget End */}
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
            {/* Footer Widget */}
            <div className="footer-widget">
              <h2 className="footer-title">Quick Links</h2>
              <ul className="footer-menu">
                <li>
                  <Link to={all_routes.aboutUs}>About</Link>
                </li>
                <li>
                  <Link to={all_routes.contactUs}>Contact Us</Link>
                </li>
                <li>
                  <Link to={all_routes.hospitals}>Hospitals</Link>
                </li>
                <li>
                  <Link to={all_routes.speciality}>Specialities</Link>
                </li>
                <li>
                  <Link to={all_routes.clinics}>Clinics</Link>
                </li>
              </ul>
            </div>
            {/* Footer Widget End */}
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
            {/* Footer Widget */}
            <div className="footer-widget footer-end">
              <div className="footer-mail">
                <p className="mail-text">Info@example.com</p>
                <p className="mail-text ph-number">
                  <Link to="tel:+15456564578">+1 54565 64578</Link>
                </p>
              </div>
              <div className="footer-subscribe">
                <p>Subscribe to get new updates</p>
                <div className="subscribe-input">
                  <form action="#">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter Email Address"
                    />
                    <button
                      type="submit"
                      className="btn-icon btn btn-primary-gradient"
                      aria-label="Subscribe"
                    >
                      <i className="isax isax-arrow-right-1" />
                    </button>
                  </form>
                </div>
              </div>
            </div>
            {/* Footer Widget End */}
          </div>
        </div>
      </div>
      {/* /Footer Top */}
      {/* Footer Bottom */}
      <div className="footer-bottom">
        {/* Copyright */}
        <div className="copyright">
          <p className="mb-0">
            Copyright © 2026{" "}
            <Link to="#" className="footer-link">
              Doccure
            </Link>
            . All Rights Reserved
          </p>
        </div>
        {/* Copyright End */}
      </div>
      {/* Footer Bottom End */}
    </div>
    <ImageWithBasePath
      src="assets/img/bg/round-element-4.svg"
      alt=""
      className="round-element-4"
    />
    <ImageWithBasePath
      src="assets/img/bg/round-element-1.svg"
      alt=""
      className="round-element-5"
    />
    <ImageWithBasePath
      src="assets/img/icons/footer-shadow-1.svg"
      alt="shadow"
      className="shadow-1"
    />
    <span className="circle-element-1" />
    <span className="circle-element-2" />
    <Link to="#" className="start-booking">
      <i className="isax isax-calendar-15" />
      <p className="mb-0">
        Start <span>Booking</span>
      </p>
    </Link>
  </footer>
</>


  )
}

export default FooterSection